import React from 'react';
import _round from 'lodash/round';
import _startCase from 'lodash/startCase';

import { Tooltip } from '@trqk/components';

/**
 * @typedef {KnownShareProps}
 * @property {number} share the known share amount
 * @property {Maybe<string>} name the name of the entity
 */
interface KnownShareProps {
    share: number;
    name: Maybe<string>;
}

/**
 * Displays the known portion of an entity's ownership for a given roleType.
 * @param props {KnownShareProps}
 */
export const KnownShare = ({ share, name }: KnownShareProps): JSX.Element => {
    const capitalizedName = name === null ? null : `${_startCase(name)}`;
    const roundedShare = `${_round(share, 0)}%`;

    const message =
        capitalizedName === null
            ? roundedShare
            : `${capitalizedName}: ${roundedShare}`;

    return (
        <Tooltip message={message} position="right">
            <div
                className="grid"
                style={{
                    gridTemplateColumns: 'auto auto',
                }}
            >
                {capitalizedName && (
                    <div
                        style={{
                            gridColumn: 1,
                            gridRow: 1,
                        }}
                        className="font-semibold text-tertiary-500 truncate mr-1"
                    >
                        {capitalizedName}
                    </div>
                )}
                <div style={{ gridColumn: 2, gridRow: 1 }}>{roundedShare}</div>
            </div>
        </Tooltip>
    );
};
